import React, { FC, useContext } from 'react'

import { withOptimizely, WithOptimizelyProps } from '@optimizely/react-sdk'
import { ButtonV2, InfoIcon } from '@vividseats/vivid-ui-kit'

import MoreInfoContext from '@/components/pages/production/components/more-info-modal/context'
import { theme } from '@/design-system/themes'
import { OPTIMIZELY_EVENT } from '@/optimizely/constants'

interface Props {
    className?: string
    fontSize?: string | number
}

const MoreInfoButton: FC<WithOptimizelyProps & Props> = ({ optimizely, className, fontSize }) => {
    const {
        dispatch: { toggleMoreInfo },
    } = useContext(MoreInfoContext)

    const onClick = () => {
        optimizely?.track(OPTIMIZELY_EVENT.moreInfoButtonClick)
        toggleMoreInfo(true)
    }

    return (
        <ButtonV2
            data-testid="more-info-button"
            importance="text"
            className={className}
            onClick={onClick}
            type="button"
        >
            <InfoIcon fontSize={fontSize} color={theme.palette.gray?.['800']} />
        </ButtonV2>
    )
}

export default withOptimizely(MoreInfoButton)
